import axiosInstance from '../axiosInterceptor/axiosInstance'
import selectedOrgId from '../../utils/helpers/selectedOrgId'

const createPlayer = async (playerData) => {
  const url = `v1/orgs/${selectedOrgId()}/players`
  const response = await axiosInstance.post(url, playerData)
  return response?.data
}

export default createPlayer
